import { render, staticRenderFns } from "./WizardStep4.vue?vue&type=template&id=9b3e112a&scoped=true"
import script from "./WizardStep4.vue?vue&type=script&lang=js"
export * from "./WizardStep4.vue?vue&type=script&lang=js"
import style0 from "./WizardStep4.vue?vue&type=style&index=0&id=9b3e112a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3e112a",
  null
  
)

export default component.exports